<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="schemeHistoryForm">
    <mat-form-field class="w-100">
      <mat-label>Scheme</mat-label>
      <mat-select [formControlName]="controls.Scheme"
                  [required]="true">
        <mat-option *ngFor="let scheme of schemes" [value]="scheme">
          {{scheme.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <app-element-input
      [label]="'Membership Number'"
      [required]="true"
      [cssClasses]="['w-100']"
      [formControlName]="controls.MembershipNumber">
    </app-element-input>

    <mat-form-field class="w-100">
      <mat-label>Association</mat-label>
      <mat-select [formControlName]="controls.AssociationCode">
        <mat-option *ngFor="let association of associations" [value]="association.key">
          {{association.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>Start Date</mat-label>
      <input matInput
             [matDatepicker]="startDatePicker"
             [formControlName]="controls.StartDate"
             [max]="schemeHistoryForm.get(controls.EndDate).value"
             required>
      <mat-datepicker-toggle matSuffix [for]="startDatePicker">
        <mat-icon matDatepickerToggleIcon>today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>End Date</mat-label>
      <input matInput
             [matDatepicker]="endDatePicker"
             [formControlName]="controls.EndDate"
             [min]="schemeHistoryForm.get(controls.StartDate).value"
             required>
      <mat-datepicker-toggle matSuffix [for]="endDatePicker">
        <mat-icon matDatepickerToggleIcon>today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!schemeHistoryForm.valid"
          (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>
